import { Reducer } from 'redux';
import { KnownAction } from './shipmentAction';
import { ShipmentState } from './shipmentModels';

/* tslint:disable */
// ----------------
// REDUCER - For a given state and action, returns the new state.
// To support time travel, this must not mutate the old state.
export const reducer: Reducer<ShipmentState> = (state: ShipmentState, action: KnownAction) => {
    if (state === null || state === undefined) {
        state = {
            shipments: [],
            loading: false
        };
    }

    switch (action.type) {
        case 'SET_SHIPMENTS':
            return Object.assign({}, state, { shipments: action.data });
        case 'SET_LOADING_SHIPMENTS':
            return Object.assign({}, state, { loading: action.data });
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/data/shipment/shiptmentReducers.ts